// File: src/common/enum/typeTicketStatusEnum.ts

/**
 * Enum com os valores esperados pelo backend, todos em maiúsculo.
 */
export enum TypeTicketStatus {
    NONE = 'NONE',
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    RESOLVED = 'RESOLVED',
    CLOSED = 'CLOSED',
    REOPENED = 'REOPENED',
    ON_HOLD = 'ON_HOLD',
}

/**
 * Versão em português do enum, caso precise para exibição.
 */
export enum TypeTicketStatusBr {
    NONE = '',
    OPEN = 'Aberto',
    IN_PROGRESS = 'Em andamento',
    RESOLVED = 'Resolvido',
    CLOSED = 'Fechado',
    REOPENED = 'Reaberto',
    ON_HOLD = 'Em espera',
}

/**
 * Mapeamento de cada valor para texto que o usuário verá na tela.
 */
export const TypeTicketStatusLabel: Record<TypeTicketStatus, string> = {
    [TypeTicketStatus.NONE]: '',
    [TypeTicketStatus.OPEN]: 'Aberto',
    [TypeTicketStatus.IN_PROGRESS]: 'Em andamento',
    [TypeTicketStatus.RESOLVED]: 'Resolvido',
    [TypeTicketStatus.CLOSED]: 'Fechado',
    [TypeTicketStatus.REOPENED]: 'Reaberto',
    [TypeTicketStatus.ON_HOLD]: 'Em espera',
};

/**
 * Mapeamento de cada valor para cor padrão para uso na UI.
 */
export const TypeTicketStatusColor: Record<TypeTicketStatus, string> = {
    [TypeTicketStatus.NONE]: '#808080',          // cinza
    [TypeTicketStatus.OPEN]: '#1E90FF',         // azul
    [TypeTicketStatus.IN_PROGRESS]: '#FFA500',  // laranja
    [TypeTicketStatus.RESOLVED]: '#228B22',     // verde
    [TypeTicketStatus.CLOSED]: '#B22222',       // vermelho escuro
    [TypeTicketStatus.REOPENED]: '#800080',     // roxo
    [TypeTicketStatus.ON_HOLD]: '#FFD700',      // amarelo
};
